module.exports = __webpack_public_path__ + "media/amble.11fd74cc.mp3";